var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPayments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8817 2.93086L20.8362 3.0391L16.4376 13.4448L12.5642 13.2773C11.6401 13.2373 10.7471 13.4192 9.92831 13.7773L12.5907 7.31136L12.6519 7.15656L12.7579 6.90924C12.7892 6.81612 12.8204 6.72301 12.8646 6.6462C14.8509 1.96156 16.9092 0.964216 20.8817 2.93086Z",
    fill: "#B7CCFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.43 2.75049L22.3811 2.86455L17.6559 13.8303H13.0122C11.9042 13.8303 10.8451 14.0584 9.88379 14.4657L12.7352 7.65492L12.8004 7.49198L12.9144 7.23128C12.947 7.13352 12.9796 7.03576 13.0285 6.95429C15.163 2.01727 17.5745 0.892997 22.43 2.75049Z",
    stroke: "#081E54",
    strokeWidth: 1.25714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2117 14.1557C30.4785 13.9275 29.6964 13.8298 28.9143 13.8298H17.6553L22.3805 2.86406L22.4294 2.75C22.6738 2.83147 22.9019 2.94553 23.1463 3.04329L26.7472 4.55861C28.7513 5.3896 30.1526 6.25317 30.9999 7.29597C31.1628 7.49149 31.2932 7.67073 31.4072 7.88255C31.5539 8.11066 31.6679 8.33877 31.7331 8.58318C31.7983 8.72982 31.8472 8.87647 31.8798 9.00682C32.3197 10.3755 32.059 12.0538 31.2117 14.1557Z",
    stroke: "#081E54",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8688 21.7795V24.9568C36.8688 25.2827 36.8525 25.6085 36.8362 25.9344C36.5266 31.621 33.3493 34.4887 27.3206 34.4887H14.6115C14.2204 34.4887 13.8294 34.4561 13.4546 34.4072C8.27317 34.065 5.50323 31.2951 5.16106 26.1136C5.11218 25.7389 5.07959 25.3478 5.07959 24.9568V21.7795C5.07959 18.5044 7.06743 15.6856 9.90255 14.4636C10.8802 14.0562 11.923 13.8281 13.031 13.8281H28.9337C29.7321 13.8281 30.5142 13.9422 31.2311 14.154C34.4736 15.1479 36.8688 18.1786 36.8688 21.7795Z",
    stroke: "#081E54",
    strokeWidth: 1.25714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5627 24.3867V25.8043C23.5627 27.0054 22.4454 27.976 21.0698 27.976C19.6941 27.976 18.5698 27.0054 18.5698 25.8043V24.3867C18.5698 25.5878 19.6871 26.4397 21.0698 26.4397C22.4454 26.4397 23.5627 25.5808 23.5627 24.3867Z",
    stroke: "#1552E8",
    strokeWidth: 1.25714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5614 22.4616C23.5614 22.8108 23.4636 23.132 23.296 23.4113C22.884 24.0886 22.0391 24.5146 21.0614 24.5146C20.0838 24.5146 19.2388 24.0817 18.8268 23.4113C18.6592 23.132 18.5615 22.8108 18.5615 22.4616C18.5615 21.8611 18.8408 21.3234 19.2877 20.9323C19.7416 20.5343 20.3631 20.2969 21.0544 20.2969C21.7458 20.2969 22.3673 20.5413 22.8212 20.9323C23.2821 21.3164 23.5614 21.8611 23.5614 22.4616Z",
    stroke: "#1552E8",
    strokeWidth: 1.25714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5627 22.4647V24.385C23.5627 25.5861 22.4454 26.438 21.0698 26.438C19.6941 26.438 18.5698 25.5791 18.5698 24.385V22.4647C18.5698 21.2636 19.6871 20.293 21.0698 20.293C21.7611 20.293 22.3826 20.5374 22.8365 20.9284C23.2834 21.3195 23.5627 21.8641 23.5627 22.4647Z",
    stroke: "#1552E8",
    strokeWidth: 1.25714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7349 7.65234L9.88351 14.4631C7.04839 15.6852 5.06055 18.504 5.06055 21.7791V17.005C5.06055 12.3775 8.35189 8.51591 12.7349 7.65234Z",
    stroke: "#081E54",
    strokeWidth: 1.25714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8642 17.0059V21.78C36.8642 18.1954 34.4853 15.1484 31.2266 14.1708C32.0738 12.0526 32.3182 10.3906 31.9109 9.00567C31.8783 8.85903 31.8294 8.71238 31.7643 8.58203C34.7949 10.1462 36.8642 13.3561 36.8642 17.0059Z",
    stroke: "#081E54",
    strokeWidth: 1.25714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0695 32.1637C15.0695 32.6664 15.0067 33.1535 14.881 33.6248C14.7396 34.2533 14.4882 34.8661 14.1582 35.4003C13.0741 37.2229 11.0787 38.4484 8.78475 38.4484C7.16643 38.4484 5.70522 37.8356 4.60539 36.83C4.13403 36.4215 3.72551 35.9345 3.41127 35.4003C2.82993 34.4576 2.5 33.342 2.5 32.1637C2.5 30.4668 3.17562 28.9113 4.27545 27.7801C5.42242 26.6017 7.02502 25.8789 8.78475 25.8789C10.6388 25.8789 12.3199 26.6802 13.4512 27.9686C14.4567 29.0842 15.0695 30.561 15.0695 32.1637Z",
    fill: "#A020FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1294 32.1367H6.44727",
    stroke: "white",
    strokeWidth: 1.11607,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.78857 29.8359V34.5338",
    stroke: "white",
    strokeWidth: 1.11607,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayments);
export default __webpack_public_path__ + "static/media/Payments.a42ee714fd2027efaa7645e1b032449e.svg";
export { ForwardRef as ReactComponent };